export var Result;
(function (Result) {
    Result["CORRECT"] = "+";
    Result["WRONG"] = "-";
    Result["CORRECTED_WRONG"] = "^";
    Result["UNANSWERED"] = "?";
})(Result || (Result = {}));
